<template>
	<el-popover v-model="show" width="208" :trigger="trigger" :placement="placement" popper-class="lang-popover">
		<ul>
			<li v-for="item in langList" :key="item.value" @click="language(item)">
				<div class="dis-fle ali-cen">
					<img :src="item.icon" />
					<span class="txt-15">{{ item.name }}</span>
				</div>
				<i v-if="defaultLang == item.value" class="el-icon-check"
					style="color: rgb(242, 152, 7); font-size: 25px;"></i>
			</li>
		</ul>

		<!-- <div slot="reference">

		</div> -->
		<template #reference>
			<slot></slot>
		</template>
	</el-popover>
</template>

<script>
import i18n from '@/i18n'
import { mapState, mapMutations } from "vuex";
export default {
	props: {
		trigger: {
			type: String,
			default: 'hover'
		},
		placement: {
			type: String,
			default: 'bottom'
		},
	},
	data() {
		return {
			show: false,
		};
	},
	computed: {
		...mapState(["defaultLang", "langList"]),
	},
	methods: {
		...mapMutations(["setDefaultLang",]),
		//语言
		language(item) {
			i18n.locale = item.value
			this.setDefaultLang(item.value)
			this.show = false
		},
	}
};
</script>

<style lang="scss">
.lang-popover {
	padding: 0px !important;
}
</style>
<style lang="scss" scoped>
ul {
	padding: 10px 0px;
	background-color: #2c2c3e;

	li {
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 60px;
		position: relative;
		padding: 0px 14px;
		cursor: pointer;

		&:hover {
			background-color: #1a1b24;
		}

		img {
			width: 25px;
			height: 25px;
		}

		span {
			margin-left: 10px;
		}
	}
}
</style>
